import { render, staticRenderFns } from "./TMenuGroup.vue?vue&type=template&id=36e0e85c&scoped=true&"
import script from "./TMenuGroup.vue?vue&type=script&lang=js&"
export * from "./TMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./TMenuGroup.vue?vue&type=style&index=0&id=36e0e85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0e85c",
  null
  
)

export default component.exports